<template>
	<div class="l-step-content-box">
		<el-form :model="form_data" label-width="80px" ref="form" :rules="rules" label-position="left" v-loading="loading">
			<el-form-item label="手机号" prop="username">
				<el-input v-model="form_data.username" autocomplete="off" placeholder="请输入手机号"></el-input>
			</el-form-item>
			<el-form-item label="姓名" prop="name">
				<el-input v-model="form_data.name" autocomplete="off" placeholder="请输入姓名"></el-input>
			</el-form-item>

			<el-form-item label="密码" prop="pwd">
				<el-input type="password" v-model="form_data.pwd" autocomplete="off" placeholder="请输入登录密码"></el-input>
			</el-form-item>

			<el-form-item label="密码确认" prop="re_pwd">
				<el-input type="password" v-model="form_data.re_pwd" autocomplete="off" placeholder="请再次输入登录密码"></el-input>
			</el-form-item>

			<el-form-item label="工号" prop="e_num">
				<el-input v-model="form_data.e_num" autocomplete="off" placeholder="请输入工号(选填)"></el-input>
			</el-form-item>
			<el-form-item label="职位" prop="position">
				<el-input v-model="form_data.position" autocomplete="off" placeholder="请输入职位(选填)"></el-input>
			</el-form-item>

			<el-form-item label="" style="margin-top: 20px">
				<el-button @click="lastStep">上一步</el-button>
				<el-button type="primary" :loading="submitting" @click="handleSubmit">下一步</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: "l-company-add-step2",
	props: {
		orgId: {
			type: [Number, String],
		},

		userName: {
			type: String,
			default: "",
		},

		mobile: {
			type: String,
			default: "",
		},
	},
	computed: {},
	data() {
		return {
			loading: false, //页面是否加载中

			//表单数据
			form_data: {
				name: "",
				org_id: "",
				position: "",
				e_num: "",
				username: "",
				pwd: "",
				re_pwd: "",
			},
			//表单验证规则
			rules: {
				name: [{ required: true, message: "角色名称不能为空", trigger: "change" }],
				username: [{ required: true, message: "手机号不能为空", trigger: "change" }],
				pwd: [{ required: true, message: "密码不能为空", trigger: "change" }],
				re_pwd: [{ required: true, message: "密码确认不能为空", trigger: "change" }],
				//   role_ids: [
				//     { type: 'array', required: true, message: '请选择角色', trigger: 'change' }
				//   ],
			},
			//提交按钮是否显示加载中
			submitting: false,
		};
	},

	mounted() {
		this.form_data.name = this.$props.userName;
		this.form_data.username = this.$props.mobile;
	},

	methods: {
		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.submitting = true;
					this.form_data.org_id = this.$props.orgId;
					this.$_invoke("user_saveCompanyAdmin", this.form_data)
						.then((ret) => {
							this.$_msg.success("保存成功");
							this.$emit("on-success");
							this.form_data.id = ret;
						})
						.finally(() => {
							this.submitting = false;
						});
				}
			});
		},

		//点击上一步
		lastStep() {
			this.$emit("on-click-last-step");
		},
	},
};
</script>
